import { Stack } from '@mui/material';
import Input from './Input';
import CustomButton from './Button';
import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { ROLES } from 'constant/enums';
import { useSelector } from 'react-redux';
import { isAdmin } from 'utils/utils';

const InputFeilds = [
  {
    name: 'firstName',
    label: 'First Name',
    type: 'text',
    maxLength: 50,
    placeholder: 'Enter first name',
    required: true
  },

  {
    name: 'lastName',
    label: 'Last Name',
    type: 'text',
    maxLength: 50,
    placeholder: 'Enter last name',
    required: true
  },

  {
    name: 'email',
    label: 'Email',
    type: 'email',
    maxLength: 50,
    placeholder: 'Enter email',
    required: true
  }
];

const UserForm = ({
  userInfo,
  setUserInfo,
  disableEmail,
  buttonText,
  buttonClose,
  handleSubmit,
  handleCancelAction,
  handleUserInfo,
  error,
  handleError,
  setShowLoader
}) => {
  const { userData, storeData, adminAccess } = useSelector((store) => store.auth);
  const getRoles = async () => {
    try {
      setShowLoader(true);
    } catch (err) {
      setShowLoader(false);
      return err;
    }
    setShowLoader(false);
  };

  useEffect(() => {
    getRoles();
  }, []);

  // setting admin store
  useEffect(() => {
    if (isAdmin(userData.roles)) {
      setUserInfo((prevState) => {
        return {
          ...prevState,
          stores: adminAccess ? [storeData?.id] : [userData?.storesList[0].storeId]
        };
      });
    }
  }, [isAdmin(userData.roles), adminAccess]);

  return (
    <form onSubmit={handleSubmit}>
      {InputFeilds.map(({ name, type, placeholder, label, required, maxLength, readOnly }) => (
        <Stack key={name} direction="row" sx={{ marginTop: '3vh' }}>
          <Input
            type={type}
            placeholder={placeholder}
            onChange={handleUserInfo}
            value={label == 'role' ? ROLES.ROLE_ADMIN : userInfo[name]}
            required={required}
            label={label}
            onFocus={() => handleError(name, null)}
            disabled={disableEmail && name === 'email'}
            maxLength={maxLength}
            name={name}
            error={error[name]}
            readOnly={readOnly}
          />
        </Stack>
      ))}

      <Stack direction="row" alignItems="center" justifyContent="flex-end" sx={{ mr: '5vh' }}>
        <CustomButton
          sx={{ ml: '15vh' }}
          type="submit"
          onClick={handleSubmit}
          endIcon={buttonText === 'Save' ? <SaveIcon /> : <AddIcon />}>
          {buttonText}
        </CustomButton>
        {buttonText !== 'Save' && (
          <CustomButton type="button" endIcon={<SaveIcon />} onClick={handleCancelAction}>
            {buttonClose}
          </CustomButton>
        )}
      </Stack>
    </form>
  );
};

UserForm.propTypes = {
  setShowLoader: PropTypes.func,
  userInfo: PropTypes.object,
  setUserInfo: PropTypes.func,
  buttonText: PropTypes.string,
  buttonClose: PropTypes.string,
  handleSubmit: PropTypes.func,
  handleCancelAction: PropTypes.func,
  handleUserInfo: PropTypes.func,
  handleError: PropTypes.func,
  roles: PropTypes.array,
  disableEmail: PropTypes.bool,
  isEdit: PropTypes.bool,
  user: PropTypes.object,
  error: PropTypes.object
};

export default UserForm;
